import { memo } from "react";
import { transportPartnershipShape } from "app/utils/propTypes";
import Paragraphs from "app/pages/.shared/Paragraphs";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg.jsx";
import Video from "app/pages/.shared/Video/Video";
import FrequencyFlyersMarketing from "@brand/FrequencyFlyersMarketing/FrequencyFlyersMarketing";
import "./TransportPartnership.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const TRANSPORT_MEDIA_SIZES = {
	small: { width: 300 },
	medium: { width: 300 },
	large: { width: 300 },
	xlarge: { width: 300 },
};

const TransportPartnership = ({ headline, intro, logo, paragraphs, photo, video }) => {
	return (
		<div className="transport-partnership">
			{headline && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="transport-partnership__title"
					component="h2"
				>
					{headline}
				</Typography>
			)}

			{logo.url && (
				<div className="transport-partnership__logo">
					<ProgressiveImg
						sizes={TRANSPORT_MEDIA_SIZES}
						src={logo.url}
						alt={logo.alt}
						thumbnail={logo.thumbnail}
					/>
				</div>
			)}

			{video && video.url && (
				<div className="transport-partnership__video">
					<Video autoplay={0} url={video.url} />
				</div>
			)}

			<FrequencyFlyersMarketing showSubLabel />

			<div className="transport-partnership__intro">
				<Paragraphs paragraphs={intro} enableHTMLFormatting={true} />
			</div>

			{photo.url && (
				<div className="transport-partnership__logo">
					<ProgressiveImg
						sizes={TRANSPORT_MEDIA_SIZES}
						src={photo.url}
						alt={photo.alt}
						thumbnail={photo.thumbnail}
					/>
				</div>
			)}

			<div className="transport-partnership__paragraphs">
				<Paragraphs paragraphs={paragraphs} enableHTMLFormatting={true} />
			</div>
		</div>
	);
};

TransportPartnership.propTypes = transportPartnershipShape;

TransportPartnership.defaultProps = { paragraphs: [], photo: {}, logo: {}, video: {} };

export default memo(TransportPartnership);
